
import { required } from "@vuelidate/validators";
const tlpplanrapor = {
  data() {
    return {
      tlpplanraporData: {
        Plan: null,
        Rapor: null,
        Baslangic: null,
        Bitis: null,
        Planlanantalepids: [],
        Yapilantalepids: [],
        Userid: null,
      },
      FormDataType: {
        Plan: { FieldName: "Plan", Field: "input", FieldTitle: "Plan Açıklama", FieldType: "text" },
        Rapor: { FieldName: "Rapor", Field: "input", FieldTitle: "Rapor Açıklama", FieldType: "text" },
        Baslangic: { FieldName: "Baslangic", Field: "date", FieldTitle: "Başlangıç Tarihi" },
        Bitis: { FieldName: "Bitis", Field: "date", FieldTitle: "Bitiş Tarihi" },
        Planlanantalepids: { FieldName: "Planlanantalepids", Field: "checkbox", FieldTitle: "Plananan Talepler", ComboDataArray: [] },
        Yapilantalepids: { FieldName: "Yapilantalepids", Field: "checkbox", FieldTitle: "Yapılan Talepler", ComboDataArray: [] },
        Kategori: {
          FieldName: "Kategori", Field: "checkbox", FieldTitle: "Kategori", ComboDataArray: [
            {
              Value: 'Kırmızı',
              Id: 'bg-danger'
            },
            {
              Value: 'Yeşil',
              Id: 'bg-success'
            },
            {
              Value: 'Mavi',
              Id: 'bg-primary'
            },
            {
              Value: 'Turkuaz',
              Id: 'bg-info'
            },
            {
              Value: 'Koyu Gri',
              Id: 'bg-dark'
            },
            {
              Value: 'Sarı',
              Id: 'bg-warning'
            },
          ]
        }
      }
    }
  },
  validations: {
    FormData: {
      Plan: { required },
      Rapor: {  },
      Bitis: {},
      Kategori: {},
      Planlanantalepids: {},
      Yapilantalepids: {}
    }
  },

  created() {

    this.ActionsFilterGet({ Service: "tlptalep", FullData: true, Filter: "&Desc=Lastmodified&Tamamlananharic=true&Atananpersonelid=" + this.TokenPersonelId }).then((res) => {
      this.FormDataType.Planlanantalepids.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Takipno + " - " + item.Baslik
      }));
    });
    this.ActionsFilterGet({ Service: "tlptalep", FullData: true, Filter: "&Desc=Lastmodified&Atananpersonelid=" + this.TokenPersonelId }).then((res) => {
      this.FormDataType.Yapilantalepids.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Takipno + " - " + item.Baslik
      }));
    });
  }

}
export default tlpplanrapor